import {
  ActionIcon,
  Affix,
  Transition,
  rem,
  useMantineTheme,
} from "@mantine/core";
import { useWindowScroll } from "@mantine/hooks";
import React from "react";
import { IconScrollToTop } from "../icons/IconScrollToTop";

const ScrollToTop = () => {
  const theme = useMantineTheme();
  const [scroll, scrollTo] = useWindowScroll();

  return (
    <>
      <Affix position={{ bottom: 20, right: 20 }}>
        <Transition transition="slide-up" mounted={scroll.y > 0}>
          {(transitionStyles) => (
            <ActionIcon
              variant="filled"
              color={theme.colors.brandBlue[4]}
              radius="xl"
              w={50}
              h={50}
              aria-label="scrollToTopBtn"
              style={transitionStyles}
              onClick={() => scrollTo({ y: 0 })}
            >
              <IconScrollToTop style={{ width: rem(16), height: rem(16) }} />
            </ActionIcon>
          )}
        </Transition>
      </Affix>
    </>
  );
};

export { ScrollToTop };
